import classNames from "classnames";
import { Trans } from "react-i18next";
import React from "react";
import { getOutlineStyle } from "services/util";

const PayRunStatus = ({ status, small=false }) => (
  <div
    // className={classNames(
    //   "d-inline-block border rounded px-2 small",
    //   {
    //     "border-warning text-warning": status === "Draft",
    //   },
    //   { "border-info text-info": status === "Approved" },
    //   { "border-success text-success": status === "Paid" }
    // )}

    // className={classNames(
    //   "badge",
    //   {
    //     " badge-warning badge-pill": status === "Draft",
    //   },
    //   { " badge-info badge-pill": status === "Approved" },
    //   { " badge-success badge-pill": status === "Paid" }
    // )}
    className="text-center"
    style={getOutlineStyle(`${
        status === "Approved" ? "#72B566" : status === "Draft" ? "#fb6340" : status === "Paid" ? "#72B566" : "default"
      }`, 
      `${small ? '0.8em' : ''}`, 
      //`${small ? '1px' : ''}`
    )}
  >
    <Trans>{status}</Trans>
  </div>
);

export default PayRunStatus;
